/* ============================================================
 * ENISSATI · Vídeos clientes (slider + modal player)
 * Section: sections/ss-video-stories.liquid · Figma 44:897
 * ============================================================ */
(function () {
  'use strict';

  var sections = document.querySelectorAll('.ss-vs');
  if (!sections.length) return;

  Array.prototype.forEach.call(sections, function (root) {
    initSection(root);
  });

  function initSection(root) {
    var slider = root.querySelector('[data-vs-slider]');
    var prev   = root.querySelector('[data-vs-prev]');
    var next   = root.querySelector('[data-vs-next]');
    var modal  = root.querySelector('[data-vs-modal]');
    var body   = root.querySelector('[data-vs-modal-body]');
    var close  = root.querySelector('[data-vs-modal-close]');

    // ---- Slider nav ----
    if (slider && prev && next) {
      function scrollByCard(dir) {
        var card = slider.querySelector('.ss-vs__card');
        var w = card ? card.offsetWidth + 16 : 280; // 16 = gap
        slider.scrollBy({ left: dir * w, behavior: 'smooth' });
      }
      prev.addEventListener('click', function () { scrollByCard(-1); });
      next.addEventListener('click', function () { scrollByCard(1); });

      function updateNav() {
        var max = slider.scrollWidth - slider.clientWidth - 2;
        prev.disabled = slider.scrollLeft <= 0;
        next.disabled = slider.scrollLeft >= max;
      }
      slider.addEventListener('scroll', updateNav, { passive: true });
      window.addEventListener('resize', updateNav);
      updateNav();
    }

    // ---- Card play → modal ----
    root.querySelectorAll('[data-vs-play]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var url = btn.dataset.videoUrl || '';
        var ext = btn.dataset.videoExternal || '';
        var title = btn.dataset.videoTitle || '';
        if (!url && !ext) return; // no video → silent
        openModal(url, ext, title);
      });
    });

    // ---- Product mini click (stop propagation pra não abrir modal) ----
    root.querySelectorAll('[data-vs-product], [data-vs-buy]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.stopPropagation();
        var handle = link.dataset.productHandle || '';
        var ctaType = link.hasAttribute('data-vs-buy') ? 'buy' : 'mini';
        gaTrack(ctaType === 'buy' ? 'video_card_buy_click' : 'video_card_product_click',
                { product_handle: handle });
      });
    });

    // ---- Modal ----
    function openModal(url, ext, title) {
      gaTrack('video_play', { video_title: title || '', source: url ? 'native' : 'external' });
      body.innerHTML = '';
      if (url) {
        var v = document.createElement('video');
        v.src = url;
        v.controls = true;
        v.autoplay = true;
        v.playsInline = true;
        v.setAttribute('preload', 'auto');
        body.appendChild(v);
      } else if (ext) {
        var ifr = document.createElement('iframe');
        ifr.src = embedify(ext);
        ifr.allow = 'autoplay; encrypted-media; picture-in-picture';
        ifr.setAttribute('allowfullscreen', '');
        body.appendChild(ifr);
      }
      modal.hidden = false;
      document.body.classList.add('ss-vs-modal-open');
      modal.focus();
    }

    function closeModal() {
      modal.hidden = true;
      body.innerHTML = '';
      document.body.classList.remove('ss-vs-modal-open');
    }

    if (close) close.addEventListener('click', closeModal);
    if (modal) modal.addEventListener('click', function (e) {
      if (e.target === modal) closeModal();
    });
    document.addEventListener('keydown', function (e) {
      if (!modal.hidden && (e.key === 'Escape' || e.key === 'Esc')) closeModal();
    });
  }

  /* YouTube/Vimeo URL → embed URL */
  function embedify(url) {
    if (!url) return '';
    // YouTube
    var m = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|v\/))([\w-]+)/);
    if (m) return 'https://www.youtube.com/embed/' + m[1] + '?autoplay=1';
    // Vimeo
    m = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    if (m) return 'https://player.vimeo.com/video/' + m[1] + '?autoplay=1';
    return url;
  }

  function gaTrack(event, params) {
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', event, params || {});
      }
    } catch (e) {}
  }
})();
